<template>
  <div>
    <BilletExcelFileListImport ref="import" v-on:uploaded="fileUpload" />
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        Planilha financeira
        <el-form style="float: right; padding: 3px 0" :inline="true">
          <el-button type="primary" @click="$refs.import.open()">Importar planilha</el-button>
        </el-form>
      </div>
      <el-form :inline="true">
        <el-row :gutter="5">
          <el-col :span="24">
            <el-form-item label="Periodo">
              <el-select v-model="month">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>

            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <BilletExcelFileDetail :list="tableData" />
    </el-card>
  </div>
</template>

<script>
import { AuditService } from "@/services/customers/audit.services";
import { UserService } from "@/services/users/user.services";
import BilletExcelFileListImport from './BilletExcelFileListImport.vue';
import BilletExcelFileDetail from "./BilletExcelFileDetail.vue";

export default {
  name: "AuditFileList",
  components: {
    BilletExcelFileListImport,
    BilletExcelFileDetail
  },
  data() {
    return {
      tableData: [],
      month: '2023-06',
      options: [{
        value: '2023-06',
        label: 'JUN/2023'
      }, {
        value: '2023-05',
        label: 'MAI/2023'
      }, {
        value: '2023-04',
        label: 'ABR/2023'
      }],
      user: {
        type: "1",
      },
    };
  },
  methods: {
    fileUpload(id, event = true) {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      AuditService.findfile(id)
        .then((response) => {
          const index = vm.tableData.findIndex(x => x.id === id);
          if (index === -1) {
            vm.tableData.unshift(response)
          } else {
            vm.tableData.splice(index, 1);
            vm.tableData.unshift(response);
          }
          if (event) {
            vm.$bus.$emit("audit", id);
          }
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    fetchRecords() {
      const vm = this;
      vm.tableData = [];
      const loading = vm.$loading(vm.$options.loading);
      AuditService.files()
        .then((response) => {
          vm.tableData = response;
        })
        .catch((error) => {
          vm.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.user.type = response.type;
      })
      .catch((error) => {
        this.$message({
          type: "error",
          message: error,
        });
      });
  },
};
</script>
<style scoped>
.el-upload--text {
  width: 100%;
}

.el-upload--text {
  width: 100%;
}
</style>